import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('GLITCH_FRAGMENTS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    if (rnd > 0.5) continue;
    const xOff = (rnd - 0.5) * 100 * progress;
    const yOff = (seedRandom(e.id, i + 50) - 0.5) * 100 * progress;
    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    ctx.fillRect(e.pos.x + xOff, e.pos.y + yOff, 10 * (1 - progress), 4);
  }
});
